import React, { useEffect, useState } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase'; // Import your Firebase db instance
import ProjectCard from '../components/ProjectCard'; // Import the ProjectCard component
import Navbar from '../components/home/Navbar'; // Assuming you have a Navbar component
import './styles/ProjectsPage.css'; // Import your CSS file

const OngoingProjectsPage = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
        setLoading(true);
        try {
          const q = query(collection(db, 'projects'), where('status', '==', 0));
          const querySnapshot = await getDocs(q);
          const projectsList = querySnapshot.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }));
          setProjects(projectsList);
        } catch (error) {
          console.error('Erreur lors de la récupération des projets : ', error);
        } finally {
          setLoading(false);
        }
      };

    fetchProjects();
  }, []);

  return (
    <div className="projects-page2">
    <Navbar />
    <div className="title-container">
      <h1 className="projects-title">Les Projets En Cours</h1>
      
    </div><br/>  
          {loading ? (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Chargement des projets...</p>
          </div>
        ) : (
          <div className="projects-list">
            {projects.length > 0 ? (
              projects.map(project => (
                <ProjectCard
                  key={project.id}
                  title={project.title}
                  photo={project.photo}
                  zone={project.zone}
                  startDate={project.startDate}
                  duration={project.duration}
                  budget={project.budget}
                  bailleur={project.bailleur}
                  globalObjective={project.globalObjective}
                  specificObjectives={project.specificObjectives}
                />
              ))
            ) : (
              <p className="no-projects">Aucun projet en cours disponible pour le moment.</p>
            )}
          </div>
        )}
      </div>
    
  );
};

export default OngoingProjectsPage;
